module.exports = __webpack_public_path__ + "static/arthur-app-gallop-717822f00aee30500a72975c16a3ec66.gif";